import mask from './mask';

export default {
    mask
}
